import { useEffect, useState } from 'react';

/** Значення із затримкою (серверний пошук у полях-посиланнях: запит не на кожну літеру, а після паузи 200 мс). */
export function useDebouncedValue<T>(value: T, delay = 200): T {
  const [current, setCurrent] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setCurrent(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return current;
}
